const emptyToNull = (value) => {
  const nextValue = value?.toString?.().trim?.() ?? "";
  return nextValue === "" ? null : nextValue;
};

const normalizeDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value.toISOString().slice(0, 10);

  const nextValue = value.toString();
  return nextValue.includes("T") ? nextValue.split("T")[0] : nextValue;
};

const isHiddenMode = (mode) =>
  mode?.toString?.().trim?.().toLowerCase?.() === "hidden";

const parsePaymentAmount = (value) => {
  if (value === undefined || value === null || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  let nextValue = value
    .toString()
    .replace(/\s/g, "")
    .replace(/[^\d,.-]/g, "")
    .trim();
  if (!nextValue) return null;

  if (nextValue.includes(",") && nextValue.includes(".")) {
    nextValue = nextValue.replace(/\./g, "").replace(",", ".");
  } else {
    nextValue = nextValue.replace(",", ".");
  }

  const amount = Number(nextValue);
  return Number.isFinite(amount) ? amount : null;
};

export const getResponsePayload = (res) =>
  res && Object.prototype.hasOwnProperty.call(res, "data") ? res.data : res;

export const isErrorResponse = (res) =>
  res?.status?.toString?.().toLowerCase?.() === "error";

export const isWarningResponse = (res) =>
  res?.status?.toString?.().toLowerCase?.() === "warning";

export const getResponseMessage = (res, fallback) =>
  res?.message ?? getResponsePayload(res)?.message ?? fallback;

export const getTransHeaderIdFromResponse = (res) => {
  const payload = getResponsePayload(res);
  return payload?.id ?? payload?.Id ?? res?.id ?? res?.Id;
};

export const buildTransHeaderExpensePayload = ({
  formValues,
  applicationId,
  transHeaderId,
}) => {
  const supplierMode = formValues?.transTypeSupplierMode;
  const shouldClearSupplier = isHiddenMode(supplierMode);
  const shouldClearDateFrom = isHiddenMode(formValues?.dateFromMode);
  const shouldClearDateTo = isHiddenMode(formValues?.dateToMode);
  const paidOnIssue =
    formValues?.paidOnIssue === true || formValues?.paymentMode === "paid";
  let paymentFields = { paidOnIssue };

  if (!transHeaderId) {
    paymentFields = paidOnIssue
      ? {
          paidOnIssue: true,
          paymentTypeId:
            formValues?.paymentTypeId === "" ||
            formValues?.paymentTypeId === undefined
              ? null
              : Number(formValues.paymentTypeId),
          paymentAmount: parsePaymentAmount(formValues?.paymentAmount),
        }
      : { paidOnIssue: false };
  }

  return {
    ...(transHeaderId ? { id: transHeaderId } : {}),
    applicationId,
    transTypeId:
      formValues?.transType === "" || formValues?.transType === undefined
        ? null
        : Number(formValues.transType),
    transDate: normalizeDate(formValues?.transDate),
    dateFrom: shouldClearDateFrom ? null : normalizeDate(formValues?.dateFrom),
    dateTo: shouldClearDateTo ? null : normalizeDate(formValues?.dateTo),
    transNumber: formValues?.transNumber?.toString?.().trim?.() ?? "",
    description: emptyToNull(formValues?.reason ?? formValues?.description),
    supplierId: shouldClearSupplier ? null : formValues?.supplierId ?? null,
    comments: emptyToNull(formValues?.comments),
    remarks: emptyToNull(formValues?.remarks),
    ...paymentFields,
  };
};
